// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__29fRP","left":"InfoRow_left__1HpSM"};